export const defaultCopy = {
  title: 'Allow biometrics',
  message:
    'In order to continue you must first allow this application to access the biometric data from this device. This helps us to protect user data and is essential to maintain privacy.',
};

export const unsupportedDeviceCopy = {
  title: 'Biometric security required',
  message:
    'To access this application you must be using a device that supports biometric security and has it enabled. Please check your device’s capability and settings or contact IT support.',
};

export const errorCopy = {
  title: 'Biometrics registration failed',
  message:
    'An error occurred while attempting to register the device authenticator. Please check your device’s capability and settings or contact IT support.',
};
